import React from 'react';
import { motion } from 'framer-motion';
export function CaseStudySection() {
  return <section className="w-full bg-brand-bg pt-8 md:pt-10 pb-6 md:pb-8 px-6" data-id="element-46">
      <div className="max-w-5xl mx-auto" data-id="element-47">
        <motion.div className="text-center mb-14" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-49">
            Ellos también empezaron desde cero
          </h2>
          <p className="text-base md:text-lg text-brand-dark/50" data-id="element-50">
            Más de <span className="text-brand-green font-semibold" data-id="element-51">150</span>{' '}
            alumnos ya aplicaron el sistema y escalaron sus resultados.
          </p>
        </motion.div>

        <motion.div className="bg-brand-card rounded-2xl border border-white/10 p-6 md:p-10 flex flex-col md:flex-row items-center gap-8 md:gap-12" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.1
      }} data-id="element-52">
          {/* Screenshot */}
          <div className="w-full md:w-1/2 flex-shrink-0" data-id="element-53">
            <div className="rounded-2xl overflow-hidden border border-white/10 shadow-lg shadow-brand-green/5" data-id="element-54">
              <img src="https://cdn.magicpatterns.com/uploads/wfRC6ompko2tTydsSZ6ii4/WhatsApp_Image_2026-03-21_at_22.16.55.jpg" alt="Captura de resultados de Susana" className="w-full h-auto object-cover" data-id="element-55" />
            </div>
          </div>

          {/* Case study info */}
          <div className="flex-1" data-id="element-56">
            <span className="inline-block px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-brand-dark bg-white/10 border border-white/15 rounded-full mb-4" data-id="element-57">
              Caso Real
            </span>
            <h3 className="text-2xl font-bold text-brand-dark mb-2" data-id="element-58">Susana</h3>
            <p className="text-lg mb-4" data-id="element-59">
              <span className="text-brand-green font-bold" data-id="element-60">
                Ya factura + de 1.500 USD por día
              </span>
            </p>
            <p className="text-brand-dark/60 leading-relaxed" data-id="element-61">
              "Venía probando de todo sin rumbo y pude{' '}
              <strong className="text-brand-dark" data-id="element-62">
                empezar a hacerlo bien
              </strong>{' '}
              y{' '}
              <strong className="text-brand-dark" data-id="element-63">
                elevar mi tasa de conversión
              </strong>
              ... ¡había que tener fe! 🙏❤️
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}